module.exports = __webpack_public_path__ + "static/media/breedon.75535c8f.png";